import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { FinancialData } from "@app/shared/interfaces/data/financial-data.interface";
import { SharedModule } from "@app/shared/shared.module";
import { FinancialCartComponent } from "../../financial-cart/financial-cart.component";
import { LogoPlaceholderComponent } from "../../logo-placeholder/logo-placeholder.component";

@Component({
  selector: 'app-top-header',
  standalone: true,
  imports: [LogoPlaceholderComponent, FinancialCartComponent, CommonModule, SharedModule],
  templateUrl: './top-header.component.html',
  styleUrl: './top-header.component.scss'
})
export class TopHeaderComponent {


  @Input() brand = '';
  @Input() model = '';
  @Input() isPortraitDevice = false;

  @Input() financialData!: FinancialData;
  isFinancialCartOpen: boolean = false;


  constructor( ) { }

  ngOnInit(): void {
    //this.isLoading = false;
  }


  //-------------------------//
  //------EVENT METHODS------//
  //-------------------------//

  isOpenedFinancialCart(evento: boolean) {
    this.isFinancialCartOpen = evento;
  }



}
